// Keyword tidying: the raw text is kept as typed; the "standard form" is
// what we compare and count by. "Emergency Plumbers  Sheffield S1" ->
// "emergency plumber".

// A UK postcode area + district ("s1", "sw1a") with an optional inward part ("2ab").
const POSTCODE_RE = /\b[a-z]{1,2}\d[a-z\d]?(?:\s*\d[a-z]{2})?\b/g;

// Left dangling once a place is removed: "plumber in sheffield" -> "plumber in".
const DANGLING_WORDS = new Set(["in", "near", "around"]);

// Simple plural -> singular. Short words and words ending in -ss/-us/-is
// are left alone ("gas", "glass", "business", "physio" etc.).
export function singularWord(word) {
  if (word.length <= 3) return word;
  if (/(ss|us|is)$/.test(word)) return word;
  if (/ies$/.test(word)) return word.slice(0, -3) + "y";
  if (/(sh|ch|x|z)es$/.test(word)) return word.slice(0, -2);
  if (/s$/.test(word)) return word.slice(0, -1);
  return word;
}

// Lowercase, single spaces, letters/numbers only, each word singular.
export function tidyPhrase(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9&\s-]/g, " ")
    .replace(/-/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map(singularWord)
    .join(" ");
}

// places: town / district names for the selected postcodes, e.g. ["Sheffield"].
export function tidyKeyword(raw, places = []) {
  let text = String(raw || "").toLowerCase().replace(POSTCODE_RE, " ");
  for (const place of places) {
    const name = String(place || "").toLowerCase().trim();
    if (!name) continue;
    text = text.replace(new RegExp(`\\b${escapeRegExp(name)}\\b`, "g"), " ");
  }
  const words = tidyPhrase(text).split(" ").filter(Boolean);
  while (words.length > 1 && DANGLING_WORDS.has(words[words.length - 1])) words.pop();
  while (words.length > 1 && DANGLING_WORDS.has(words[0])) words.shift();
  return words.join(" ");
}

// True when every word of "phrase" appears, in order and side by side, in "text".
// Both should already be tidied.
export function containsPhrase(text, phrase) {
  if (!text || !phrase) return false;
  return ` ${text} `.includes(` ${phrase} `);
}

// The sub-group whose trigger word appears in the keyword. When several
// match, the longest trigger wins ("flat roof repair" -> Flat Roofs, not Repairs).
// Returns the sub-group or null.
export function tagSubGroup(standardForm, subGroups) {
  let best = null;
  let bestLength = 0;
  for (const group of subGroups || []) {
    for (const trigger of group.trigger_words || []) {
      const tidy = tidyPhrase(trigger);
      if (tidy.length > bestLength && containsPhrase(standardForm, tidy)) {
        best = group;
        bestLength = tidy.length;
      }
    }
  }
  return best;
}

function escapeRegExp(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
